import React from "react";
import GoogleMapReact from "google-map-react";
import { LocationPin } from "./LocationPin";
import "components/generic/GoogleMapsStyles.scss";
import config from "clientappsetting.json";

type Props = {
    address: string;
    lat: number;
    lng: number;
    zoomLevel: number;
    language?: string; 
    region?: string; 
};

export const GoogleMaps = (props: Props) => {
     const {
        language = "en-GB",
        region = "GB",
    } = props;

    const languageTag = language.split("-")[0];

    const options = React.useMemo(() => ({
    panControl: false,
    draggable: false,
    mapTypeControl: true,
    scrollwheel: false,
    fullscreenControl: false,
    streetViewControl: true,
    controlSize: 28,
    }), []);

    return (
        <div className="google-map">
            <GoogleMapReact 
                options={options} 
                bootstrapURLKeys={{ 
                    key: config.GOOGLEMAPS_API_KEY, 
                    language: languageTag,
                    region, 
                    id: `google-map-api-${languageTag}-${region}`, 
                }} 
                center={{ lat: props.lat, lng: props.lng }} 
                defaultZoom={props.zoomLevel}>
                <LocationPin />
            </GoogleMapReact>
        </div>
    );
};
